export default function (state, payload) {
  state.azubiIdsToLoadTermine = payload.azubiIdsToLoadTermine
  return {
    ...state,
  }
}
